//NPM LIBRARIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AUradio } from '@gov.au/control-input';
import { AUlabel, AUfieldset, AUformGroup, AUhintText } from '@gov.au/form';

class RadioButtonGroup extends Component {
    constructor(props) {
        super(props);
        let selectedValue = ''

        if (props.existingAnswer && props.existingAnswer.radioValue) {
            selectedValue = props.existingAnswer.radioValue 
        } else {
            if (props.initialValue) {
                selectedValue = props.initialValue
            }
        }

        const selectedOption = this.props?.radioSet.find(option => option.value === selectedValue)       
  
        let optionObject = {
            radioValue: selectedValue,
            value: selectedOption?.optionLabel ?? ''
        }

        if (this.props.onChangeFunction) {
            this.props.onChangeFunction(optionObject)
        }
        
        this.state = {
            selectedValue: selectedValue
        }
    }

    onChangeRadio = (e) => {
        this.setState({
            selectedValue: e.target.value
        })

        const selectedOption = this.props.radioSet.find(option => option.value === e.target.value)
        let optionObject = {
            radioValue: e.target.value,
            value: selectedOption.optionLabel
        }
        
        this.props.returnRadioValue(optionObject);

        if (this.props.onChangeFunction) {
            this.props.onChangeFunction(optionObject)
        }
    }

    createInput = (radioSet) => {
        return (
            radioSet.map((option, key) => {
                return (
                    <AUradio
                        label={option.optionLabel}
                        name={option.name}
                        id={option.id}
                        key={key}
                        block
                        disabled = {option.disable}
                        onChange={this.onChangeRadio}
                        value={option.value}
                        checked={this.state.selectedValue === option.value ? true : false} 
                        status={this.props.status}
                        aria-describedby={`${this.props.id}-error`} />
                )
            })
        )
    }

    render() {
        return (
            <AUformGroup
                status={this.props.status}>

                <AUfieldset>
                    <AUlabel text={this.props.label} htmlFor={this.props.id} />
                    {this.props.hintText ? <AUhintText text={this.props.hintText} /> : ""}
                    <AUformGroup>
                        {this.createInput(this.props.radioSet)}
                    </AUformGroup>
                </AUfieldset>
                {this.props.createErrorMessage(this.props.errorMessage)}
            </AUformGroup>
        )
    }
}

RadioButtonGroup.propTypes = {
    radioSet: PropTypes.array.isRequired,
    status: PropTypes.bool,
    label: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    hintText: PropTypes.string,
    errorMessage: PropTypes.string,
    existingAnswer: PropTypes.object,
    returnRadioValue: PropTypes.func,
    createErrorMessage: PropTypes.func,
    onChangeFunction: PropTypes.func,
    initialValue: PropTypes.string
}

export default RadioButtonGroup;